// extracted by mini-css-extract-plugin
module.exports = {"container":"categories_dropdown-module--container--33-sY","checkbox":"categories_dropdown-module--checkbox--1teQt","listItem":"categories_dropdown-module--listItem--3tEwf"};